import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';
import Button from './Button';
import { useTheme } from 'components/ThemeProvider';

const ThemeToggle = ({ className = '' }) => {
  const { t } = useTranslation('common');
  const { theme, setTheme } = useTheme();
  const [isTransitioning, setIsTransitioning] = useState(false);

  const isDark = theme === 'dark';
  const nextMode = isDark ? t('theme.light') : t('theme.dark');

  const toggleTheme = () => {
    setIsTransitioning(true);
    document.body.style.transition = 'background-color 300ms ease, color 300ms ease';

    setTheme(isDark ? 'light' : 'dark');

    setTimeout(() => {
      document.body.style.transition = '';
      setIsTransitioning(false);
    }, 300);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      disabled={isTransitioning}
      className={`
        h-10 w-10 rounded-md transition-all duration-150 ease-out
        hover:scale-102 hover:bg-muted
        ${className}
      `}
      title={t('theme.switchToMode', { mode: nextMode })}
      aria-label={t('theme.switchToMode', { mode: nextMode })}
    >
      <div className="relative w-[18px] h-[18px]">
        {/* Light mode icon */}
        <Icon
          name="Sun"
          size={18}
          color="currentColor"
          strokeWidth={2}
          className={`
            absolute inset-0 transition-all duration-300 ease-in-out
            ${!isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 rotate-90 scale-75'}
          `}
        />

        {/* Dark mode icon */}
        <Icon
          name="Moon"
          size={18}
          color="currentColor"
          strokeWidth={2}
          className={`
            absolute inset-0 transition-all duration-300 ease-in-out
            ${isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-75'}
          `}
        />
      </div>
    </Button>
  );
};

export default ThemeToggle;
